import Image from 'next/image';
type PartnerContentProps = {
  logo: string;
  name: string;
  title: string;
};
const PartnerContent: React.FC<PartnerContentProps> = ({
  logo,
  name,
  title
}) => {
  return <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-3xl" data-sentry-component="PartnerContent" data-sentry-source-file="PartnerContent.tsx">
      <div className="text-center bg-white/50 backdrop-blur-[9.4px] rounded-3xl p-8 w-80 h-52 flex flex-col items-center group">
        <div className="filter m-auto grayscale group-hover:grayscale-0 transition-all duration-300 brightness-50 group-hover:brightness-100">
          <Image src={logo} alt={name} width={150} height={150} className="object-contain max-h-14" data-sentry-element="Image" data-sentry-source-file="PartnerContent.tsx" />
        </div>
        <p className="mt-4 text-base font-medium w-full text-center">{title}</p>
      </div>
    </div>;
};
export default PartnerContent;